import { Stack } from '@mui/material'
import { ShiftOptions } from 'models/ICattlesData'
import { CardStandart } from 'ui/CardStandart'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { DeviationChart } from './chart/DeviationChart'
import { useDeviationChartData } from './hooks/useDeviationChartData'
import DeviationIndicators from './indicator/DeviationIndicators'

interface ChartDeviationCardProps {
	daysBetweenDates: number
	startDate: number
	endDate: number
	parlorId: number[] | 'all'
	shift: ShiftOptions[] | 'all'
}

export const ChartDeviationCard = ({
	daysBetweenDates,
	startDate,
	endDate,
	parlorId,
	shift,
}: ChartDeviationCardProps) => {
	const {
		milkingGraph,
		isLoading,
		categories,
		timestamp,
		interpolatedCategories,
		hasGraphData,
		shiftCountsByDate,
		shiftCountsByTimestamp,
	} = useDeviationChartData({
		startDate,
		endDate,
		daysBetweenDates,
		shift,
		parlorId,
	})

	return (
		<CardStandart
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
				padding: '24px',
			}}
		>
			<TypographyHeader>Динамика отклонений</TypographyHeader>
			<Stack direction={'column'} gap={'24px'} mt={'24px'}>
				<DeviationIndicators milkingGraph={milkingGraph} />
				<DeviationChart
					categories={categories}
					interpolated={interpolatedCategories}
					timestamp={timestamp}
					dateBetweenDates={daysBetweenDates}
					isLoading={isLoading}
					milkingGraph={milkingGraph}
					isPlaceholder={!hasGraphData}
					shiftCountsByDate={shiftCountsByDate}
					shiftCountsByTimestamp={shiftCountsByTimestamp}
				/>
			</Stack>
		</CardStandart>
	)
}
